<script lang="ts" setup>
import { NxtLoadingScreen, useLoadingScreen } from '@nxtpeople/nxt-styles';
import { useKeycloak } from '@nxtpeople/nxt-vue-keycloak';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';
import Notifications from './core/components/Notifications.vue';

//#region Loading Screen
const { isPending } = useKeycloak();
const { showLoadingScreen, animationComplete } = useLoadingScreen(isPending);
//#endregion
</script>

<template>
   <div class="app">
      <router-view v-slot="{ Component }">
         <Transition
            name="fade"
            mode="out-in"
         >
            <NxtLoadingScreen
               v-if="showLoadingScreen"
               :module-key="ModuleKey.NxtForm"
               @animation-complete="animationComplete = true"
            />
            <component
               v-else
               :is="Component"
            />
         </Transition>
         <Notifications />
      </router-view>
   </div>
</template>

<style src="@nxtpeople/nxt-styles/dist/style.css"></style>

<style lang="scss">
.app {
   height: 100vh;
}
</style>
